import LegalPageLayout from '../../components/legal/LegalPageLayout'

export default function CookiesPolicyPage() {
  return (
    <LegalPageLayout
      title="Cookies Policy"
      subtitle="SynthetIQ Signals®, Inc."
      effectiveDate="To be set upon legal review — not yet in effect"
      lastUpdated="2026-09-25 (draft)"
      bannerText="Placeholder — pending legal team review. The vendor table below is only partially confirmed against what this site actually runs today — see the notes inline. Do not treat this page as final."
      intro={[
        'SynthetIQ Signals®, Inc. ("SynthetIQ Signals®," "we," "us," or "our") operates synthetiqsignals.com (the "Site") and, under license from Mimeograph Holdings, LLC, the 23Controls™ platform and Graffiti™ OS (the "Platform"). We use cookies and similar technologies to collect and store information about your device and usage to improve performance and enhance your experience.',
        'By using our Site and Platform, you consent to our use of cookies in accordance with this policy and the preferences you set in the cookie consent banner. Disabling certain cookies may significantly impair functionality.',
      ]}
      sections={[
        {
          heading: '1. What Are Cookies',
          paragraphs: [
            'Cookies are small text files downloaded to your device when you visit a website, enabling the site to recognize your device on later visits.',
          ],
          list: [
            'First-party cookies: served directly by SynthetIQ Signals®.',
            'Third-party cookies: set by external service providers, managed by them, not by us.',
            'Session cookies: deleted when you close your browser.',
            'Persistent cookies: remain until they expire or you delete them.',
          ],
        },
        {
          heading: '2. Similar Technologies',
          paragraphs: [
            'We may use web beacons (tracking pixels) alongside cookies to recognize site visits and measure campaign performance. The Platform may also use local storage (localStorage/sessionStorage) to store preferences and session data.',
          ],
        },
        {
          heading: '3. How We Use Cookies',
          paragraphs: ['We use cookies for:'],
          list: [
            'Essential operations: core functionality, secure login, and API authentication.',
            'Performance and analytics: tracking usage patterns and measuring Site performance.',
            'Preference storage: remembering your settings and customizations.',
            'Security: detecting and preventing fraudulent activity and unauthorized access.',
            'Service improvement: ongoing improvement based on user interaction data.',
          ],
        },
        {
          heading: '4. Strictly Necessary Cookies',
          table: {
            headers: ['Cookie', 'Source', 'Purpose', 'Duration'],
            rows: [
              ['session_id', 'synthetiqsignals.com / 23controls.com', 'Maintains session state', 'Session'],
              ['csrf_token', 'synthetiqsignals.com / 23controls.com', 'Prevents cross-site request forgery', 'Session'],
              ['auth_token', '23controls.com', 'Secures API authentication', '7 days'],
              ['cookie_consent', 'synthetiqsignals.com', 'Stores your cookie preferences', '1 year'],
            ],
          },
          note: 'This table reflects the cookies the site\'s own login/session/consent mechanisms would reasonably set, based on the auth architecture described in the codebase. It was not captured from a live devtools session in this pass — confirm against the actual deployed site before publishing.',
        },
        {
          heading: '5. Analytics, Functional, and Marketing Cookies',
          paragraphs: [
            'The original draft of this policy named Google Analytics, Mixpanel, Segment, HubSpot, LinkedIn, and Facebook/Meta as analytics and marketing vendors. None of those were found integrated into the current synthetiqsignals.com codebase during this review — no corresponding script tags or SDK imports were located.',
          ],
          note: 'Do not publish a named vendor list until someone confirms, against the live site (browser devtools network tab, or the analytics/ads platform accounts directly) or the current codebase, which of these — if any — are actually running. An inaccurate vendor list is itself a compliance problem, not just an omission. Until confirmed, this section should describe categories only ("we may use analytics or advertising cookies from third-party providers") rather than naming specific companies.',
        },
        {
          heading: '6. Third-Party Services',
          paragraphs: [
            'Stripe is used for payment processing on the 23Controls™ commerce platform. We do not control cookies set by third-party services; refer to their respective privacy policies.',
          ],
        },
        {
          heading: '7. Managing Cookie Preferences',
          paragraphs: [
            'A consent banner on first visit lets you accept all cookies, reject non-essential cookies, or customize preferences by category. You can change your preferences at any time via the "Cookies" link in the site footer.',
            'Most browsers also let you view, delete, or block cookies through their own settings. Blocking cookies may affect site functionality; strictly necessary cookies cannot be disabled. This site does not currently respond to "Do Not Track" browser signals, due to a lack of industry standardization.',
          ],
        },
        {
          heading: '8. Cookies and Personal Data',
          paragraphs: [
            'Some cookies collect personal data. Any personal data collected through cookies is processed per our Privacy Policy.',
          ],
        },
        {
          heading: '9. Updates to This Policy',
          paragraphs: [
            'We may update this policy to reflect changes in our practices, technologies, or legal requirements. We will notify you of material changes by posting the updated policy with a new "Last Updated" date.',
          ],
        },
        {
          heading: '10. Contact Us',
          paragraphs: [
            'SynthetIQ Signals®, Inc.',
            'Email: privacy@synthetiq.io',
          ],
        },
      ]}
    />
  )
}
